import { createAction, createReducer } from '@reduxjs/toolkit';
import { RootState } from 'ducks';

export interface EkrisState {
  enabled: boolean;
  gameOver: boolean;
}

const initialState: EkrisState = {
  enabled: false,
  gameOver: false
};

type ExtendedRootState = RootState & {
  ekris?: EkrisState;
};

export const startGame = createAction('ekris/startGame');
export const endGame = createAction('ekris/endGame');
export const setGameOver = createAction<boolean>('ekris/gameOver');

export const isGameEnabled = (state: ExtendedRootState) => state.ekris?.enabled;
export const isGameOver = (state: ExtendedRootState) => state.ekris?.gameOver;

export const ekrisReducer = createReducer(initialState, builder => {
  builder
    .addCase(startGame, state => {
      state.enabled = true;
    })
    .addCase(endGame, state => {
      state.enabled = false;
    })
    .addCase(setGameOver, (state, action) => {
      state.gameOver = action.payload;
    });
});
